import Cookies from 'js-cookie'

const TokenKey = 'loginToken'
const UserId = 'userId'
export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}
export function setUserId(userId) {
  return Cookies.set(UserId,String(userId))
}
export function removeUserId() {
  return Cookies.remove(UserId)
}
export function getUserId() {
  return Cookies.get(UserId)
}


// WEBPACK FOOTER //
// ./src/utils/auth.js